module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom2.7fff5cdc.jpg";